export enum UserQueryMode {
  ALL_USERS = 'all-users',
  ONLY_ISSUE_TYPE_MANAGERS = 'only-issue-type-managers',
}
